export default "__VITE_ASSET__DvFo$DyY__"